import { call, put, select, takeLatest } from 'redux-saga/effects';

import fbEmmiter from '../../../events/facebookEvents';
import { addCustomGTMEvent } from '../../../events/googleTagManager';
import { formatError, mergeLinesKits } from '../../../libs';
import cartAPI from '../../api/cart';
import { Creators as CartCreators, Types } from '../../reducers/cart';
import { Creators as DeliveryCrators } from '../../reducers/delivery';
import { getCookie, setCookie } from '../../utils/cookies';
import getState from '../../utils/getState';
import getToken from '../../utils/getToken';

function* cartAddRequest({ products = [], ctx = null }) {
  try {
    const { app } = yield select(getState);
    const token = yield select(getToken, ctx);
    const domain = app.getIn(['config', 'domain']);
    const siteId = app.getIn(['config', 'siteId']);
    const cartId = yield select(getCookie, { name: 'cart.id', ctx, domain });
    const customerId = yield select(getCookie, { name: 'customer.id', ctx, domain });
    const leadPhone = yield select(getCookie, { name: 'lead.setted-phone', ctx, domain });

    const [{ dataLayer }] = products;

    const body = { produtos: products };

    if (customerId) body.customer = customerId;

    const data = yield call(cartAPI.addItem, cartId, body, token, siteId);

    if (data.id) setCookie('cart.id', data.id, ctx, { domain });

    const lines = [];

    for (let index = 0; index < products.length; index++) {
      const element = mergeLinesKits(data.lines, data.kits).find((elm) => elm.product.sku === products[index].sku);

      if (element) lines.push(element);
    }

    yield put(CartCreators.cartAddSuccess(data));

    if (data.freight) yield put(DeliveryCrators.deliveryRequest(true));

    addCustomGTMEvent({
      event: 'success_add_to_cart',
      data: dataLayer,
      clear: true,
    });

    lines.map((line) =>
      fbEmmiter('AddToCart', {
        content_name: line.product?.name,
        content_ids: [line.product?.base],
        content_type: 'product',
        value: line.product?.price,
        currency: 'BRL',
      })
    );
  } catch (error) {
    addCustomGTMEvent({
      event: 'error_add_to_cart',
      data: null, // TODO: probably should specialize the errors in order to may have the dataLayer here as well
      clear: true,
    });

    yield put(CartCreators.cartAddFailed(formatError(error)));
  }
}

export default function* watch() {
  yield takeLatest(Types.CART_ADD_REQUEST, cartAddRequest);
}
